import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import OtherLinesContext from './OtherLinesContext';
import FeatureFlags from '../services/FeatureFlags';

const OtherLinesProvider = ({ children }) => {
  const [isOtherLines, setIsOtherLines] = useState(false);
  const [beneficiaryNumber, setBeneficiaryNumber] = useState('');
  const [segment, setSegment] = useState('');
  const [credit, setCredit] = useState(0);
  const [paymentType, setPaymentType] = useState(null);
  const [actionType, setActionType] = useState(null);
  const [errorCredit, setErrorCredit] = useState(false);

  const [flagOtherLines, setFlagOtherLines] = useState(false);
  useEffect(() => {
    FeatureFlags.getFeatureFlag('mis_otras_lineas')
      .then(res => {
        const { isEnabled } = res[0];
        setFlagOtherLines(isEnabled);
      })
      .catch(() => {
        setFlagOtherLines(false);
      });
  }, []);

  return (
    <OtherLinesContext.Provider
      value={{
        isOtherLines,
        setIsOtherLines,
        beneficiaryNumber,
        setBeneficiaryNumber,
        credit,
        setCredit,
        paymentType,
        setPaymentType,
        actionType,
        setActionType,
        errorCredit,
        setErrorCredit,
        flagOtherLines,
        segment,
        setSegment,
      }}
    >
      {children}
    </OtherLinesContext.Provider>
  );
};

OtherLinesProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default OtherLinesProvider;
